import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PieChart(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "PieChart", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.9648 28.7376c0 3.4591 1.1828 6.6415 3.1654 9.1662.2026.258.586.2806.818.0486l8.5274-8.5274c.2158-.2158.3827-.4755.4895-.7614s.151-.5914.1295-.8959l-.92-13.0189c-.0236-.3332-.3386-.57-.6643-.4959-6.611 1.5044-11.5455 7.4181-11.5455 14.4847Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.8209 43.5926c3.2136 0 6.1884-1.021 8.619-2.7555.2661-.1899.3057-.5708.086-.8128l-8.4582-9.3181c-.0582-.0642-.1289-.1159-.2077-.152-.0788-.036-.1642-.0557-.2508-.0578-.0867-.0021-.1729.0134-.2533.0457-.0805.0322-.1536.0804-.2149.1417l-8.7519 8.7519c-.2284.2283-.2112.6052.0387.8095 2.5596 2.092 5.8295 3.3474 9.3931 3.3474Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M43.6751 28.7375c0-4.3161-1.8413-8.2015-4.7805-10.9157-.2431-.2244-.6294-.1808-.8187.0903l-6.9637 9.9716c-.1694.2425-.2514.5353-.2326.8305.0188.2952.1373.5752.3361.7942l8.0732 8.8942c.2207.2431.6062.2393.8198-.0102 2.2231-2.5967 3.5664-5.9686 3.5664-9.6549Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m28.2773 14.467.8012 11.3389c.0252.3567.4848.4837.6895.1905l6.5599-9.3933c.1843-.2639.1025-.6302-.1774-.7892-2.1625-1.2292-4.6634-1.9318-7.3287-1.9318h-.0059c-.3143.0001-.5607.2713-.5386.5849ZM4.37305 4.40723h4.55728v2.48521H4.37305V4.40723Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4.32422 9.14453H15.7576v2.48527H4.32422V9.14453Zm0 4.73737h9.20998v2.4852H4.32422v-2.4852Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
PieChart.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PieChart"
};
validateTidalLicense();
export {
  PieChart
};
//# sourceMappingURL=PieChart.js.map
